import { ApiRequestConfig, apiService } from './api.service';

import { IGroupResponse } from '@/interfaces/entities/group';
import { IApiService } from '@/interfaces/services/IApiService';

class GroupService {
	[x: string]: any;
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async getAllGroups(pageNumber: number) {
		return await this.api.get<{
			data: IGroupResponse[];
			pageCount: number;
		}>(`/groups?page[size]=10&page[number]=${pageNumber}&sort[createdAt]=DESC`);
	}

	async deleteGroup(id: string) {
		return await this.api.delete(`/groups/${id}`);
	}
}

export const groupService = new GroupService(apiService);
